import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    class: "log-container",
    ref: "log-container"
};
const _hoisted_2 = { class: "table table-striped table-sm" };
const _hoisted_3 = { style: { "width": "160px" } };
const _hoisted_4 = { style: { "max-width": "50%" } };
const _hoisted_5 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
            _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logsToShow, (log, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                        key: log.timestamp + idx.toString()
                    }, [
                        _createElementVNode("td", _hoisted_3, [
                            _createElementVNode("small", null, _toDisplayString(log.timestamp), 1)
                        ]),
                        _createElementVNode("td", null, [
                            _createElementVNode("small", null, _toDisplayString(_ctx.getMessage(log)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_4, [
                            _createElementVNode("small", {
                                innerHTML: log.parameters
                            }, null, 8, _hoisted_5)
                        ])
                    ]));
                }), 128))
            ])
        ])
    ], 512));
}
